import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';

import { StylistService } from 'src/app/services';

export interface ValidationResult {
  [key: string]: { valid: boolean };
}

@Injectable({
  providedIn: 'root'
})
export class StylistEmailChecker {
  constructor(private stylistService: StylistService) {}

  public stylistEmailAvailabilityChecker(): (
    control: UntypedFormControl
  ) => Observable<ValidationResult> {
    const stylistService = this.stylistService;

    return (control: UntypedFormControl): Observable<ValidationResult> => {
      const email = control.value;

      return new Observable<ValidationResult>((observer) => {
        if (email === '' || email === undefined || email === null) {
          observer.next(null);
          observer.complete();
          return;
        }

        stylistService.emailChecker(email).subscribe({
          next: (available: boolean) => {
            if (available) {
              observer.next(null);
            } else {
              observer.next({
                stylistEmailAvailability: {
                  valid: false
                }
              });
            }

            observer.complete();
          },
          error: (error) => {
            observer.next({
              stylistEmailAvailability: {
                valid: false
              }
            });
            observer.complete();
          }}
        );
      });
    };
  }
}
